export const SET_TAILORS = 'app/tailor/SET_TAILORS';
export const ADD_TAILOR_PLACE_DETAILS = 'app/tailor/ADD_TAILOR_PLACE_DETAILS';
